import GameEvent from '../classes/event';
import store from '../store';
import { EventBus } from '../api/eventbus';

const _events = [
    new GameEvent({
        name:      'EVT_STRIKE',
        type:      'strike',
        bonusType: 'strike',
        isGood:    false
    }),
    new GameEvent({
        name:        'EVT_FIRE',
        type:        'shop',
        shop:        'LemonadeStand',
        bonusType:   'modifyProductionTime',
        isGood:      false,
        bonusFactor: 0.5,
        isAvailable: () => {
            let shop = store.getters.getShopByID('LemonadeStand');
            return shop.amount > 0;
        }
    }),
    new GameEvent({
        name:        'EVT_FIRE',
        type:        'shop',
        shop:        'PaperDelivery',
        bonusType:   'modifyProductionTime',
        isGood:      false,
        bonusFactor: 0.8,
        isAvailable: () => {
            let shop = store.getters.getShopByID('PaperDelivery');
            return shop.amount > 0;
        }
    }),
    new GameEvent({
        name:        'EVT_FIRE',
        type:        'shop',
        shop:        'ShoeShop',
        bonusType:   'modifyProductionTime',
        isGood:      false,
        bonusFactor: 0.75,
        isAvailable: () => {
            let shop = store.getters.getShopByID('ShoeShop');
            return shop.amount > 0;
        }
    }),
    new GameEvent({
        name:        'EVT_FIRE',
        type:        'shop',
        shop:        'PizzaDelivery',
        bonusType:   'modifyProductionTime',
        isGood:      false,
        bonusFactor: 0.75,
        isAvailable: () => {
            let shop = store.getters.getShopByID('PizzaDelivery');
            return shop.amount > 0;
        }
    }),
    new GameEvent({
        name:        'EVT_FIRE',
        type:        'shop',
        shop:        'Bakery',
        bonusType:   'modifyProductionTime',
        isGood:      false,
        bonusFactor: 0.75,
        isAvailable: () => {
            let shop = store.getters.getShopByID('Bakery');
            return shop.amount > 0;
        }
    }),
    new GameEvent({
        name:        'EVT_FIRE',
        type:        'shop',
        shop:        'LampStore',
        bonusType:   'modifyProductionTime',
        isGood:      false,
        bonusFactor: 0.8,
        isAvailable: () => {
            let shop = store.getters.getShopByID('LampStore');
            return shop.amount > 0;
        }
    }),
    new GameEvent({
        name:        'EVT_FIRE',
        type:        'shop',
        shop:        'SoccerTeam',
        bonusType:   'modifyProductionTime',
        isGood:      false,
        bonusFactor: 0.75,
        isAvailable: () => {
            let shop = store.getters.getShopByID('SoccerTeam');
            return shop.amount > 0;
        }
    }),
    new GameEvent({
        name:        'EVT_FIRE',
        type:        'shop',
        shop:        'MovieStudio',
        bonusType:   'modifyProductionTime',
        isGood:      false,
        bonusFactor: 0.75,
        isAvailable: () => {
            let shop = store.getters.getShopByID('MovieStudio');
            return shop.amount > 0;
        }
    }),
    new GameEvent({
        name:        'EVT_FIRE',
        type:        'shop',
        shop:        'Airline',
        bonusType:   'modifyProductionTime',
        isGood:      false,
        bonusFactor: 0.85,
        isAvailable: () => {
            let shop = store.getters.getShopByID('Airline');
            return shop.amount > 0;
        }
    }),
    new GameEvent({
        name:        'EVT_FIRE',
        type:        'shop',
        shop:        'Bank',
        bonusType:   'modifyProductionTime',
        isGood:      false,
        bonusFactor: 0.75,
        isAvailable: () => {
            let shop = store.getters.getShopByID('Bank');
            return shop.amount > 0;
        }
    }),
    new GameEvent({
        name:        'EVT_FIRE',
        type:        'shop',
        shop:        'CarManufacturer',
        bonusType:   'modifyProductionTime',
        isGood:      false,
        bonusFactor: 0.75,
        isAvailable: () => {
            let shop = store.getters.getShopByID('CarManufacturer');
            return shop.amount > 0;
        }
    }),
    new GameEvent({
        name:        'EVT_FIRE',
        type:        'shop',
        shop:        'DrugRing',
        bonusType:   'modifyProductionTime',
        isGood:      false,
        bonusFactor: 0.6,
        isAvailable: () => {
            let shop = store.getters.getShopByID('DrugRing');
            return shop.amount > 0;
        }
    }),
    new GameEvent({
        name:        'EVT_BOOST',
        type:        'shop',
        shop:        'LemonadeStand',
        bonusType:   'modifyProductionTime',
        isGood:      true,
        bonusFactor: 1.5,
        isAvailable: () => {
            let shop = store.getters.getShopByID('LemonadeStand');
            return shop.amount > 0;
        }
    }),
    new GameEvent({
        name:        'EVT_BOOST',
        type:        'shop',
        shop:        'PaperDelivery',
        bonusType:   'modifyProductionTime',
        isGood:      true,
        bonusFactor: 1.8,
        isAvailable: () => {
            let shop = store.getters.getShopByID('PaperDelivery');
            return shop.amount > 0;
        }
    }),
    new GameEvent({
        name:        'EVT_BOOST',
        type:        'shop',
        shop:        'ShoeShop',
        bonusType:   'modifyProductionTime',
        isGood:      true,
        bonusFactor: 1.75,
        isAvailable: () => {
            let shop = store.getters.getShopByID('ShoeShop');
            return shop.amount > 0;
        }
    }),
    new GameEvent({
        name:        'EVT_BOOST',
        type:        'shop',
        shop:        'PizzaDelivery',
        bonusType:   'modifyProductionTime',
        isGood:      true,
        bonusFactor: 1.75,
        isAvailable: () => {
            let shop = store.getters.getShopByID('PizzaDelivery');
            return shop.amount > 0;
        }
    }),
    new GameEvent({
        name:        'EVT_BOOST',
        type:        'shop',
        shop:        'Bakery',
        bonusType:   'modifyProductionTime',
        isGood:      true,
        bonusFactor: 1.75,
        isAvailable: () => {
            let shop = store.getters.getShopByID('Bakery');
            return shop.amount > 0;
        }
    }),
    new GameEvent({
        name:        'EVT_BOOST',
        type:        'shop',
        shop:        'LampStore',
        bonusType:   'modifyProductionTime',
        isGood:      true,
        bonusFactor: 1.8,
        isAvailable: () => {
            let shop = store.getters.getShopByID('LampStore');
            return shop.amount > 0;
        }
    }),
    new GameEvent({
        name:        'EVT_BOOST',
        type:        'shop',
        shop:        'SoccerTeam',
        bonusType:   'modifyProductionTime',
        isGood:      true,
        bonusFactor: 1.75,
        isAvailable: () => {
            let shop = store.getters.getShopByID('SoccerTeam');
            return shop.amount > 0;
        }
    }),
    new GameEvent({
        name:        'EVT_BOOST',
        type:        'shop',
        shop:        'MovieStudio',
        bonusType:   'modifyProductionTime',
        isGood:      true,
        bonusFactor: 1.75,
        isAvailable: () => {
            let shop = store.getters.getShopByID('MovieStudio');
            return shop.amount > 0;
        }
    }),
    new GameEvent({
        name:        'EVT_BOOST',
        type:        'shop',
        shop:        'Airline',
        bonusType:   'modifyProductionTime',
        isGood:      true,
        bonusFactor: 1.85,
        isAvailable: () => {
            let shop = store.getters.getShopByID('Airline');
            return shop.amount > 0;
        }
    }),
    new GameEvent({
        name:        'EVT_BOOST',
        type:        'shop',
        shop:        'Bank',
        bonusType:   'modifyProductionTime',
        isGood:      true,
        bonusFactor: 1.75,
        isAvailable: () => {
            let shop = store.getters.getShopByID('Bank');
            return shop.amount > 0;
        }
    }),
    new GameEvent({
        name:        'EVT_BOOST',
        type:        'shop',
        shop:        'CarManufacturer',
        bonusType:   'modifyProductionTime',
        isGood:      true,
        bonusFactor: 1.75,
        isAvailable: () => {
            let shop = store.getters.getShopByID('CarManufacturer');
            return shop.amount > 0;
        }
    }),
    new GameEvent({
        name:        'EVT_BOOST',
        type:        'shop',
        shop:        'DrugRing',
        bonusType:   'modifyProductionTime',
        isGood:      true,
        bonusFactor: 1.6,
        isAvailable: () => {
            let shop = store.getters.getShopByID('DrugRing');
            return shop.amount > 0;
        }
    }),
    new GameEvent({
        name:        'New competitor!',
        type:        'shop',
        shop:        'LemonadeStand',
        bonusType:   'decreaseEarnings',
        isGood:      false,
        bonusFactor: 0.5
    }),
    new GameEvent({
        name:      'EVT_JACKPOT',
        bonusType: 'increaseBalance',
        isGood:    true,
        cost:      150000
    }),
    new GameEvent({
        name:      'EVT_BEAUTY_CONTEST',
        id:        'ev1f',
        bonusType: 'increaseBalance',
        isGood:    true,
        cost:      200
    }),
    new GameEvent({
        name:            'EVT_GENERAL_REPAIRS',
        bonusType:       'decreaseBalance',
        isGood:          false,
        bonusFactorType: 'allShopsAmount',
        cost:            0,
        singleCost:      10
    }),
    new GameEvent({
        name:      'EVT_CROSSWORD',
        bonusType: 'increaseBalance',
        isGood:    true,
        cost:      200
    }),
    new GameEvent({
        name:            'EVT_FLOOD',
        bonusType:       'decreaseBalance',
        isGood:          false,
        bonusFactorType: 'currentBalance',
        bonusFactor:     0.8
    }),
    new GameEvent({
        name:            'EVT_SHOP_USEBILITY',
        bonusType:       'increaseBalance',
        isGood:          true,
        bonusFactorType: 'increaseBalance',
        cost:            25000
    }),
    new GameEvent({
        name:            'EVT_CEASE_DESIST',
        bonusType:       'decreaseBalance',
        isGood:          false,
        bonusFactorType: 'currentBalance',
        bonusFactor:     0.1
    }),
    new GameEvent({
        name:            'EVT_BANK_ERROR_NOT_FAVOR',
        bonusType:       'decreaseBalance',
        isGood:          false,
        bonusFactorType: 'currentBalance',
        bonusFactor:     0.5
    }),
    new GameEvent({
        name:            'EVT_ROBBERY',
        bonusType:       'decreaseBalance',
        isGood:          false,
        bonusFactorType: 'currentBalance',
        bonusFactor:     0.75
    }),
    new GameEvent({
        name:            'EVT_BANK_ERROR_FAVOR',
        bonusType:       'increaseBalance',
        isGood:          true,
        bonusFactorType: 'currentBalance',
        bonusFactor:     2.5
    })
];

_events.map((event, i) => {
    event.id = i;
    return event;
});

const getEvents       = () => _events,
    getRandomTimeSpan = (min, max) => Math.floor(Math.random() * (max - min) + min),
    startRandomEvent  = () => {
        let event = _events[Math.floor(Math.random() * _events.length)];
        event.apply()
            .then(res => {
                EventBus.$emit('addEventMessage', event);
                EventBus.$emit('playSound', event.isGood ? 'goodEvent' : 'badEvent');
                if (res.isApplied === true) {
                    startTimer();
                    return true;
                }
                res.isApplied.then(() => {
                    startTimer();
                    return true;
                });
            })
            .catch(() => {
                startRandomEvent();
            });
    },
    startTimer       = () => {
        setTimeout(startRandomEvent, getRandomTimeSpan(60 * 1000, 60 * 60 * 1000));
    };

export default {
    getEvents,
    startTimer
};
